module.exports = __webpack_public_path__ + "static/img/JACK-GORDON.905fb5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JACK-GORDON.jpg
// module id = ln6U
// module chunks = 0